import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { Amplify } from 'aws-amplify';
import Cognito from "./Configurations/cognito";
import getGraphQLConfig from "./Configurations/graphql";
import getStorageConfig from "./Configurations/storage.js";
const storage = getStorageConfig();
try {
    Amplify.configure({

        Auth: {
            Cognito: Cognito(),
            // Cognito: {
            //     userPoolId: "us-east-1_ANsP6lGfr",
            //     userPoolClientId: "cgeq354gfocbv1acd58ll8pcr",
            //     signUpVerificationMethod: "code",
            //     loginWith: {
            //         email: true,
            //     },
            // },
        },

        API: {
            // GraphQL: {
            //     endpoint:
            //         "https://bpfl3y5qcrgltamunmoloyz35e.appsync-api.us-east-1.amazonaws.com/graphql",
            //     region: "us-east-1",
            //     defaultAuthMode: "userPool",
            // },
            GraphQL: getGraphQLConfig()

        },
        Storage: {
            S3: {
                buckets: storage.buckets,
            },
        }
    });
} catch (error) {
    console.error("Amplify configuration error:", error);
}

createApp(App).use(store).use(router).use(vuetify).mount('#app')
